import { useRouteError } from 'react-router';

import { ErrorBoundary } from '../components/general';

export const RouterError = () => {
  const err = useRouteError();
  return <ErrorBoundary error={err} />;
};
